// The composer "+" menu — a WhatsApp-style grid of message actions. Only ready
// actions are enabled; the rest show a "Soon" badge (they light up as each ships:
// GIF, Poll, Event, File — see docs/conversations/07-composer-actions.md).
import React from 'react';
import { Sparkles, Image as ImageIcon, BarChart3, ClipboardCheck, Folder, Music, Smile, type LucideIcon } from 'lucide-react';

interface Tile {
  key: string;
  label: string;
  icon: LucideIcon;
  active: boolean;
  onClick?: () => void;
}

export const PlusMenu: React.FC<{ onDana: () => void; onGif?: () => void; onPoll?: () => void; onFile?: () => void; onAssignment?: () => void; onMusic?: () => void; onEmoji?: () => void; onClose: () => void }> = ({
  onDana,
  onEmoji,
  onGif,
  onPoll,
  onFile,
  onAssignment,
  onMusic,
  onClose,
}) => {
  // Each active tile switches the composer menu to its own picker (which replaces this
  // "plus" menu) — so it must NOT also call onClose(): both mutate the same menu state
  // and onClose would win, closing everything instead of opening the picker.
  const tiles: Tile[] = [
    { key: 'dana', label: 'Dana', icon: Sparkles, active: true, onClick: onDana },
    { key: 'emoji', label: 'Emoji', icon: Smile, active: !!onEmoji, onClick: onEmoji },
    { key: 'gif', label: 'GIF', icon: ImageIcon, active: !!onGif, onClick: onGif },
    { key: 'poll', label: 'Poll', icon: BarChart3, active: !!onPoll, onClick: onPoll },
    { key: 'file', label: 'File', icon: Folder, active: !!onFile, onClick: onFile },
    { key: 'assignment', label: 'Assignment', icon: ClipboardCheck, active: !!onAssignment, onClick: onAssignment },
    { key: 'music', label: 'Music', icon: Music, active: !!onMusic, onClick: onMusic },
  ];
  return (
    <div className="absolute bottom-full left-0 z-20 mb-2 w-64 rounded-xl border border-border bg-card p-2 shadow-lg">
      <div className="grid grid-cols-3 gap-1">
        {tiles.map((tile) => (
          <button
            key={tile.key}
            type="button"
            disabled={!tile.active}
            onClick={tile.onClick}
            className={`flex flex-col items-center gap-1 rounded-lg p-2.5 text-center ${
              tile.active ? 'hover:bg-muted' : 'cursor-default opacity-50'
            }`}
          >
            <tile.icon className={`h-5 w-5 ${tile.active ? 'text-primary-500' : 'text-muted-foreground'}`} />
            <span className="text-[11px] leading-tight text-charcoal">{tile.label}</span>
            {!tile.active && <span className="text-[9px] text-muted-foreground">Soon</span>}
          </button>
        ))}
      </div>
    </div>
  );
};
